import * as React from 'react';
import {CheckCircleOutline, HighlightOff} from "@mui/icons-material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Praktisches Ergebnis -> Anzeige. Der Eingang wird in jedem Fall per E-Mail bestätigt.
const STATUS_MESSAGES = {
    STORNO_REQUESTED: "Da deine Bestellung noch nicht versendet wurde, haben wir eine Stornierung angefragt. Du erhältst eine separate Rückmeldung.",
    ORDER_CANCELLED: "Deine Bestellung wurde storniert.",
    RETURN_INITIATED: "Wir leiten die Rücksendung ein. Bitte sende die Ware auf eigene Kosten an die unten genannte Adresse.",
    DEADLINE_EXPIRED: "Die gesetzliche Widerrufsfrist ab Zustellung ist bereits abgelaufen. Ein Widerruf ist daher nicht mehr möglich.",
    ORDER_NOT_FOUND: "Wir konnten deine Bestellung nicht eindeutig zuordnen. Der Händler prüft deinen Widerruf und meldet sich bei dir.",
    RECORDED: "Dein Widerruf wurde erfasst. Der Händler bearbeitet ihn und meldet sich bei dir.",
    RECEIVED: "Dein Widerruf wurde erfasst. Der Händler bearbeitet ihn und meldet sich bei dir.",
};

const DHL_FRANK_LINK = "https://www.dhl.de/de/privatkunden/pakete-versenden/online-frankieren.html?type=RetoureLandingPage&rosyId=c71c4046b157400f84b33082c84dbc07";

export default function WiderrufSuccess({status, email, hasExternalItems}) {
    const showReturnInfo = status === 'RETURN_INITIATED';
    const rejected = status === 'DEADLINE_EXPIRED';

    return (
        <SoftBox textAlign="center">
            {rejected
                ? <HighlightOff color="error" sx={{fontSize: 64, mb: 1}}/>
                : <CheckCircleOutline color="success" sx={{fontSize: 64, mb: 1}}/>}
            <SoftTypography variant="h4" fontWeight="bold" mb={1}>
                {rejected ? "Widerruf nicht möglich" : "Widerruf eingegangen"}
            </SoftTypography>
            <SoftTypography variant="body2" color="text" mb={2}>
                Eine Bestätigung mit Datum und Uhrzeit haben wir dir
                {email ? <> per E-Mail an <strong>{email}</strong></> : <> per E-Mail</>} gesendet.
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
                {STATUS_MESSAGES[status] ?? STATUS_MESSAGES.RECEIVED}
            </SoftTypography>

            {showReturnInfo && (
                <>
                    <SoftBox mt={2}>
                        <SoftTypography variant="caption" color="secondary">
                            Bitte sende dein Paket an folgende Adresse:<br/>
                            <strong>Simple Retouren</strong><br/>
                            <strong>Aufzug Gräser GbR</strong><br/>
                            <strong>Cuxhavener Straße 386</strong><br/>
                            <strong>21149 Hamburg</strong>
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox mt={2}>
                        <SoftButton mt={2} variant="gradient" color="primary">
                            <SoftTypography variant='h6' color='white'>
                                Versandetikett selbst frankieren:&nbsp;
                                <a target='_blank' rel='noreferrer' href={DHL_FRANK_LINK}>
                                    <strong>Weiter zu DHL</strong>
                                </a>
                            </SoftTypography>
                        </SoftButton>
                    </SoftBox>
                </>
            )}

            {hasExternalItems && (
                <SoftBox mt={2}>
                    <SoftTypography variant="caption" color="warning">
                        Hinweis: Artikel, die nicht von uns versendet wurden, wickelt der Händler direkt mit dir ab –
                        bitte sende diese <strong>nicht</strong> an uns.
                    </SoftTypography>
                </SoftBox>
            )}
        </SoftBox>
    );
}
